export const HAWKERS_REPORT_PT_BR = {
	title: "Painel Ambulantes",
	description: "Veja a performance geral dos ambulantes no local",
	general: {
		title: "Painel Geral",
		hawkerSelect: "Selecione um ambulante",
		totalizers: {
			launchedProductsTotal: "Total de produtos lançados",
			returnedProductsTotal: "Total de produtos devolvidos",
			commissionTotal: "Total em comissões",
			salesTotal: "Total em vendas",
		},
		table: {
			sales: "Vendas",
			devolutions: "Devoluções",
			paymentMethod: "Métodos de pagamento",
			productsRelease: "Lançamento de produtos",
			productsCancellation: "Cancelamento de produtos",
			noReturnNoSalesProducts: "Produtos sem devolução e sem venda",
			columns: {
				product: "Produto",
				quantity: "Quantidade",
				unitValue: "Valor unitário",
				total: "Total",
				commission: "Comissão",
				paymentMethod: "Método de pagamento",
				value: "Valor",
			},
		},
	},
	summary: {
		title: "Resumo por sessão e ciclo",
		summary: "Resumo",
		filterBreak: "Mostrar apenas sessões com quebras",
		filterClosure: "Mostrar apenas sessões com fechamento pendente",
		filterDifferentCashiers: "Mostrar apenas sessões com caixas diferentes",
		columns: {
			session: "Sessão",
			hawkerName: "Ambulante",
			pub: {
				initial: "Bar de abertura",
				final: "Bar de fechamento",
			},
			hawkerDocument: "Documento",
			cycleCount: "Ciclos",
			change: "Troco",
			receivedValue: "Valor recebido",
			break: "Quebra de caixa",
			openedAt: "Abertura",
			closedAt: "Fechamento",
			openClosure: "Fechamento em aberto",
			cycle: "Ciclo",
			previousBalance: "Saldo anterior",
			closingValue: "Valor fechamento",
			balance: "Saldo final",
			cashierNameOpener: "Abertura caixa",
			cashierNameCloser: "Fechamento caixa",
		},
	},
	ranking: {
		title: "Ranking",
		filename: "ranking",
		columns: {
			name: "Nome",
			document: "Documento",
			commission: "Comissão",
			total: "Total Vendido",
		},
	},
	releases: {
		title: "Lançamentos por ambulantes",
		quantityProducts: "Qtd de produtos",
		totalValueReleases: "Valor total",
		filename: "ficha-ambulante-{{hawker}}",
		hawkerRecord: "Ficha Ambulante",
		name: "Nome do ambulante",
		columns: {
			hawkerName: "Nome",
			hawkerDocument: "Documento",
			total: "Total",
			productName: "Produto",
			quantity: "Quantidade",
			value: "Valor unitário",
			cycle: "Ciclo",
			date: "Data/Hora",
		},
	},
	cashierClosing: {
		title: "Fechamento de caixa de ambulante",
		name: "Nome",
		document: "Documento",
		begin: "Abertura",
		end: "Fechamento",
		closingValue: "Valor fechamento",
		financialResume: "Resumo financeiro",
		resume: "Resumo",
		value: "Valor",
		products: "Produtos",
		product: "Produto",
		quantity: "Quantidade",
		unitValue: "Valor unitário",
		total: "Total",
		paymentMethods: "Métodos de pagamento",
		paymentMethod: "Método de pagamento",
		date: "Data e hora",
		changeEntries: "Lançamentos de troco",
		bleedings: "Sangrias",
		cycleClosings: "Fechamentos de ciclos",
		sessionClosings: "Fechamentos de sessões",
		financialSummaryTitles: {
			changeFundsValue: "Total de troco",
			bleedingsValue: "Total de sangria",
			cyclesReceivedValue: "Totalizador de ciclos",
			sessionsReceivedValue: "Totalizador de sessões",
			cashValue: "Valor em dinheiro",
			valueWithCashier: "Valor em posse do caixa",
			cashierDiffValue: "Caixa fechado com quebra/sobra",
			commissionsValue: "Comissão",
		},
		diffValue: "Quebra/Sobra de caixa",
	},
	filter: {
		filter: "Filtrar",
		clickToFilter: "Clique pra filtrar",
		employee: {
			label: "Funcionário",
			description: "Digite o nome do funcionário",
			title: "Filtrar por funcionário",
		},
		hawkerName: {
			label: "Nome do ambulante",
			description: "Digite o nome do ambulante",
			title: "Filtrar por nome do ambulante",
		},
		hawkerDocument: {
			label: "Documento do ambulante",
			description: "Digite o documento do ambulante",
			title: "Filtrar por documento do ambulante",
		},
		cashierName: {
			label: "Nome do caixa",
			description: "Digite o nome do caixa",
			title: "Filtrar por nome do caixa",
		},
		cashierDocument: {
			label: "Documento do caixa",
			description: "Digite o documento do caixa",
			title: "Filtrar por documento do caixa",
		},
		eventTypes: {
			label: "Tipo de movimentação",
			description: "Selecione o tipo de movimentação",
			title: "Filtrar por tipo de movimentação",
		},
		productName: {
			label: "Nome do produto",
			description: "Digite o nome do produto",
			title: "Filtrar por nome do produto",
		},
		barName: {
			label: "Nome do bar",
			description: "Digite o nome do bar",
			title: "Filtrar por nome do bar",
		},
		cycleId: {
			label: "Ciclo",
			description: "Digite o ID do ciclo",
			title: "Filtrar por ciclo",
			error: "Por favor, insira um ID válido",
		},
		sessionId: {
			label: "Sessão",
			description: "Digite o ID da sessão",
			title: "Filtrar por sessão",
			error: "Por favor, insira um ID válido",
		},
		employeeLogin: {
			label: "Login do funcionário",
			description: "Digite o login do funcionário",
			title: "Filtrar por login do funcionário",
		},
	},
	transactions: {
		title: "Transações de Ambulante",
		description: "Lista de transações do ambulante em escopo de place",
		columns: {
			id: "ID da movimentação",
			hawkerName: "Nome do Ambulante",
			hawkerDocument: "Documento do Ambulante",
			productId: "ID do Produto",
			productName: "Produto",
			barId: "ID do bar",
			barName: "Nome do bar",
			cashierId: "ID do Caixa",
			cashierName: "Nome do Caixa",
			cashierDocument: "Documento do Caixa",
			employeeName: "Nome do Funcionário",
			cycleId: "Ciclo",
			openedAt: "Data e Hora de Abertura",
			closedAt: "Data e Hora de Fechamento",
			eventType: "Tipo de Movimentação",
			createdAt: "Data/hora de Movimentação",
			eventId: "Event ID",
			eventName: "Nome do Evento",
			quantity: "Quantidade",
			amount: "Valor",
			paymentMethod: "Método de pagamento",
			paymentValue: "Valor pago",
			unitValue: "Valor unitário",
			totalValue: "Valor total",
			sessionId: "Sessão",
			discount: "Desconto",
			commission: "Comissão",
			balance: "Saldo do fechamento ciclo/sessão",
			employeeLogin: "Login do funcionário",
			serial: "Serial do terminal",
			deviceId: "Device ID do terminal",
			productTotal: "Total do produto",
			hawkerEmployee: "Login do funcionário do ambulante",
			cashierEmployee: "Login do funcionário do caixa",
		},
		filter: {
			actionsType: "Selecione um tipo de movimentação",
			employee: "Nome de funcionário",
			hawker: "Nome ou documento de ambulante",
			cashier: "Nome ou documento de caixa",
		},
		sessionOpening: "Abertura de sessão",
		sessionClosure: "Fechamento de sessão",
		cycleOpening: "Abertura de ciclo",
		cycleClosure: "Fechamento de ciclo",
		productRelease: "Solta de ambulante",
		sale: "Vendas de ambulante",
		bleeding: "Lançamento de sangria",
		changeFund: "Lançamento de troco",
		devolution: "Devoluções de produtos de ambulantes",
		cashierOpening: "Abertura de caixa",
		cashierClosure: "Fechamento de caixa",
		cancellation: "Cancelamento",
		maxSearchPeriod: "O período máximo de busca é de 31 dias",
	},
};

export type HawkersReportTranslations = typeof HAWKERS_REPORT_PT_BR;
